@let isMobile = isMobile$ | async;

<div class="nordic-blue-900-bg surface-contrast" id="booking-header-summary-section" role="region">
  <div class="relative">
    <div
      data-id="status-bar-location-container"
      class="col-1-12 overflow-hidden flex flex--middle white-text text-icon-reversed"
      [class.flex--wrap]="isManageMyBookingSubheader() === false"
      [class.flex--nowrap]="isManageMyBookingSubheader()"
    >
      @if (isManageMyBookingSubheader() === false) {
        <fin-booking-header-summary-item
          data-testid="summary-item-trip-type"
          [isClickable]="isClickable"
          (clickAction)="openBookingWidget($event)"
          [type]="SelectorType.TRIP_TYPE"
          *ngIf="bookingSummary().tripType !== TripType.MULTICITY && isMobile === false"
          customClasses="pr-xxsmall-r border-right ms-xxsmall-l white-text text-icon-reversed flex"
        >
          <span class="content">
            {{ 'tripCard.tripType.' + bookingSummary().tripType | finLocalization }}
          </span>
        </fin-booking-header-summary-item>
      }

      @if (bookingSummary().tripType !== TripType.MULTICITY) {
        <fin-booking-header-summary-item
          (clickAction)="openBookingWidget($event)"
          [isClickable]="isClickable"
          [type]="SelectorType.ORIGIN"
          customClasses="pr-xxsmall-x flex"
          data-testid="summary-item-origin"
        >
          <span class="content">
            <span>
              {{ bookingSummary().locations?.[0].originLocationCode }}
            </span>
          </span>
        </fin-booking-header-summary-item>

        <span class="flex flex--middle cursor" (click)="isMobile ? openBookingWidget(null) : null">
          <fcom-icon class="icon-small" [name]="tripTypeIcon()" />
        </span>
        <fin-booking-header-summary-item
          (clickAction)="openBookingWidget($event)"
          [isClickable]="isClickable"
          [type]="SelectorType.DESTINATION"
          customClasses="pr-xxsmall-x flex border-right"
          data-testid="summary-item-destination"
        >
          <span class="content">
            <span>
              {{ bookingSummary().locations?.[0].destinationLocationCode }}
            </span>
          </span>
        </fin-booking-header-summary-item>
      } @else {
        <fin-booking-header-summary-item
          customClasses="pr-xxsmall-x border-right flex"
          [type]="SelectorType.LOCATION_COMBO"
          data-testid="summary-item-location-combo"
        >
          <span class="content">
            <span>
              {{ 'tripCard.tripType.complex' | finLocalization }}
            </span>
            <span class="flex--nogrow ps-xxsmall-x">
              <fcom-icon class="icon-small" [name]="SvgLibraryIcon.AIRCRAFT_HORIZONTAL" />
            </span>
            <span>
              {{
                isMobile
                  ? bookingSummary().locations.length
                  : ('bookingWidget.numberOfFlights'
                    | finLocalization: { numberOfFlights: bookingSummary().locations.length })
              }}
            </span>
          </span>
        </fin-booking-header-summary-item>
      }
      @if (isManageMyBookingSubheader() === false) {
        <fin-booking-header-summary-item
          (clickAction)="openBookingWidget($event)"
          [isClickable]="isClickable"
          [type]="SelectorType.PAX"
          customClasses="pr-xxsmall-x border-right flex"
          data-testid="summary-item-pax"
        >
          <span class="content">
            <fcom-icon
              class="icon-small"
              [name]="bookingSummary().paxAmount !== 1 ? SvgLibraryIcon.MULTI_PAX : SvgLibraryIcon.SINGLE_PAX"
            />

            {{ bookingSummary().paxAmount }}
          </span>
        </fin-booking-header-summary-item>
      }
      <fin-booking-header-summary-item
        (clickAction)="openBookingWidget($event)"
        [isClickable]="isClickable"
        [type]="SelectorType.TRAVEL_DATES"
        customClasses="pr-xxsmall-l ms-xxsmall-r flex"
        data-testid="summary-item-travel-dates"
      >
        <span class="content">
          {{
            bookingSummary().dates?.returnDate
              ? (bookingSummary().dates?.departureDate | finDateFormat: 'DATE_SHORT') +
                ' - ' +
                (bookingSummary().dates?.returnDate | finDateFormat: 'DATE_SHORT')
              : (bookingSummary().dates?.departureDate | finDateFormat: 'FULL_NO_YEAR')
          }}
        </span>
      </fin-booking-header-summary-item>
    </div>
  </div>
</div>
